import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ y: 40, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="hero-line-mask">
    <motion.span
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={`block ${className}`}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ index, label, title, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-center gap-4 mb-4">
      {index && <span className="font-mono-spec text-[#334772] text-sm tracking-widest">{index}</span>}
      <span className="h-px w-10 bg-[#334772]" />
      <span className="font-mono-spec text-[11px] tracking-[0.3em] uppercase text-[#706F70]">{label}</span>
    </div>
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#334772] uppercase">
      {title}
    </h2>
  </Reveal>
);

export const SpecChip = ({ children }) => (
  <span className="inline-block font-mono-spec text-[10px] tracking-[0.2em] uppercase text-[#706F70] border border-[#334772]/25 px-3 py-1.5">
    {children}
  </span>
);
